<template>
    <div ref="subTable" class="text-area">
        <p v-for="(t, i) in theText" v-bind:key="i" v-html="t"></p>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import $ from 'jquery';
import current from '@/scripts/current';
import { mapGetters, mapState } from 'vuex';
import store from '@/store';

export default {
    props: {
        forReport: {
            default: false
        }
    },
    components: {},
    mounted: function () {
        const vm = this;
        store.dispatch('loadedControls/mounted', {
            name: 'myHelp',
            vm,
            setHeight: (h) => {
                const vm = this;
                vm.$refs.subTable.setAttribute(
                    'style',
                    `max-height: ${h}px; min-height: ${h}px;`
                );
            }
        });
    },
    computed: {
        isEnabled() {
            return this.selectionModel.v[this.variableType].include;
        },
        variableSelectionType() {
            return this.selectionModel.v[this.variableType].type;
        },
        variable() {
            return this.selectionModel.v[this.variableType].variable;
        },
        ...mapGetters({
            userNeedsHelp: 'selModel/getUserNeedsHelp'
        }),
        stateSelectionModel() {
            return store.state.selModel;
        }
    },
    watch: /*deep/no deep*/ {
        selectionModel: {
            handler: function () {
                update(this);
            },
            deep: true
        },
        stateSelectionModel: {
            handler: function () {
                update(this);
            },
            deep: true
        },
        userNeedsHelp(value) {
            if (value) {
                store.dispatch('selModel/resetUserNeedsHelp');
                $([document.documentElement, document.body]).animate(
                    {
                        scrollTop: $('.text-area').offset().top
                    },
                    500
                );
            }
        }
    },
    data: function () {
        var vm = this;
        var helpState = current.helpHelper.getHelpState(current.selectionModel);
        return {
            current: current,
            selectionModel: current.selectionModel,
            helpState: helpState,
            theText: vm.buildHelpText(current.helpText.getText(helpState))
        };
    },
    methods: {
        buildHelpText: function (value) {
            var text = this.format(value);
            var seconds = store.state.selModel.executionStats.seconds;
            if (
                seconds >= 30 &&
                current.selectionModel.currentStep !== 'years' &&
                (current.selectionModel.currentStep !== 'location' ||
                    store.state.selModel.locations.ids.length > 0)
            ) {
                var threshold = seconds >= 60 ? '60' : '30';
                var warning =
                    'The analysis you requested will take over ' +
                    threshold +
                    ' seconds to finish. To reduce completion time, try decreasing the complexity of the analysis by limiting the number of selected years, locations, or variables.';
                text.unshift(warning);
            }
            return text;
        },
        format: function (value) {
            //return value;
            //Following code will strip off code
            if (value.length === 0) return value;
            var lastLine = value[value.length - 1];
            if (lastLine.length >= 4 && lastLine.length <= 6) {
                return value.splice(0, value.length - 1);
            } else return value;
        }
    }
};

function update(vm) {
    vm.helpState = current.helpHelper.getHelpState(vm.selectionModel);
    vm.theText = vm.buildHelpText(current.helpText.getText(vm.helpState));
}
</script>

<style scoped>
.text-area {
    height: 100%;
    box-sizing: border-box;
    /* max-height: 250px; */
    min-height: 150px;
    resize: none;
    overflow-y: auto;
    width: 100%;
    background-color: white;
    border: 1px solid #ccc;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    -webkit-transition: border linear 0.2s, box-shadow linear 0.2s;
    -moz-transition: border linear 0.2s, box-shadow linear 0.2s;
    -o-transition: border linear 0.2s, box-shadow linear 0.2s;
    transition: border 0.2s linear ease-in-out,
        box-shadow linear 0.2s ease-in-out;
}
p {
    /*padding: 4px 4px 0px 4px;*/
    margin: 8px 8px 8px 8px;
}

@media (min-width: 768px) {
}

@media (max-width: 767px) {
    .text-area {
        overflow-y: visible;
        max-height: none;
    }
}

@media print {
    .text-area {
        overflow-y: visible;
        max-height: none;
    }
}

h4 {
    margin-bottom: 0px;
    margin-top: 0px;
    width: auto;
}

@media (min-width: 768px) {
    .visible-xs {
        display: none;
    }
}

/* @import "../css/half-container.css"; */
</style>